import Spinner from '../Spinner/Spinner'
import styles from './LoadingPlaceholder.module.scss'

export interface Props {
  size?: number
}

const LoadingPlaceholder = ({
  size
}: Props) =>
  <div
    aria-busy
    aria-label='Loading'
    aria-live='polite'
    className={styles.LoadingPlaceholder}
    role='status'
  >
    <Spinner size={size} />
  </div>

export default LoadingPlaceholder
